/**
 * 같은 원인의 에러를 묶기 위한 핑거프린트.
 * 메시지의 숫자(아이디·크기 등 가변 파라미터)와 스택의 번들 해시·행/열 번호를
 * 정규화해 재배포나 파라미터 차이에도 같은 값이 나오게 한다.
 */

const MAX_MESSAGE_CHARS = 200
const MAX_FRAMES = 3

function fnv1a64Hex(input: string): string {
  let hash = 0xcbf29ce484222325n
  const prime = 0x100000001b3n
  const mask = 0xffffffffffffffffn
  for (let i = 0; i < input.length; i++) {
    hash ^= BigInt(input.charCodeAt(i))
    hash = (hash * prime) & mask
  }
  return hash.toString(16).padStart(16, '0')
}

function normalizeMessage(message: string): string {
  return message.slice(0, MAX_MESSAGE_CHARS).replace(/\d+/g, 'N')
}

function normalizeFrame(line: string): string {
  return line
    .trim()
    // 오리진 제거: https://apps.wrks.ai/notes/assets/... → assets/...
    .replace(/https?:\/\/[^/\s)]+\//g, '')
    // 번들 해시 제거: index-Bv2X9z_k.js → index.js
    .replace(/([\w.]+)-[A-Za-z0-9_-]{6,}\.(m?js)/g, '$1.$2')
    // 행:열 번호 제거 (빌드마다 달라짐)
    .replace(/:\d+(?::\d+)?/g, '')
}

function topFrames(stack: string): string[] {
  const frames: string[] = []
  for (const line of stack.split('\n')) {
    const trimmed = line.trim()
    // V8: "at fn (url)", Firefox/Safari: "fn@url"
    if (/^at\s/.test(trimmed) || /@/.test(trimmed)) {
      frames.push(normalizeFrame(trimmed))
      if (frames.length >= MAX_FRAMES) break
    }
  }
  return frames
}

export function computeFingerprint(name: string, message: string, stack?: string): string {
  const parts = [name, normalizeMessage(message), ...(stack ? topFrames(stack) : [])]
  return fnv1a64Hex(parts.join(' '))
}
